import Components from '../../common/Components';
import size from './Size';

// tracks information about an input to be rendered in a InputList
export default class InputInformation {

	constructor({
			type,
			key,
			additionalElements,
			validationTypes,
			dynamicProps,
			field,
			render,
			...rest
		}) {
		switch (type) {
			case Components.BUTTON:
			case Components.CALENDAR_INPUT:
			case Components.CHECKBOX:
			case Components.DELAYED_TEXT_AREA:
			case Components.DELAYED_TEXT_INPUT:
			case Components.FILE_UPLOAD:
			case Components.LINK:
			case Components.PLAIN_TEXT:
			case Components.POP_OVER:
			case Components.SEGMENTED_BUTTON:
			case Components.SELECT_INPUT:
			case Components.TEXT_AREA:
			case Components.TEXT_INPUT:
				break;
			default:
				console.error('Unknown InputInformation type: ' + type);
				break;
		}

		// these options are passed directly to the component
		// view the actual component for a full list of proptypes available/required
		// == Required == //
		// what type of input, uses Components constants
		this.type = type ? type : false;

		// Most every component requires a field to say to which field of the data this field is bound
		this.field = field ? field : undefined;

		// == Optional == //
		// want to put anything else after the input? like a search button? or a help icon? or your mamma's phone #?
		this.additionalElements = additionalElements ? additionalElements : [];

		// can pass which rules an input will use; these will be used when create a validation engine
		// use ValidationType enum or actual ValidationRule object that could have been created with ValidationRules enum.
		this.validationTypes = validationTypes ? validationTypes : undefined;

		// can pass dynamic value functions for this input information's properties. this is helpful for the value property as well as any dynamic property
		// ie. new InputInformation({type: Components.TEXT_INPUT, field: 'field1', dynamicProps: {value: () => this.state.data.field1, disabled: () => this.state.data.field1Disabled}})
		// the above would dynamically set value and disabled based on the functions
		// note that, for setting input information values, the preferred way is to still use the data={this.state.data} attribute of InputList. DyanmicProps is for anything besides data.
		this.dynamicProps = dynamicProps ? dynamicProps : undefined;

		// always have a key; use field if not present since field should always be unique in a set of fields
		this.key = key || this.field || rest.keyName;

		// if render is false then the input is skipped in the inputlist
		// this allows turning inputs on/off without having to splice and dice your InputInformation array
		this.render = render === undefined ? true : !!render;

		// Also include all the other passed in options
		// InputInformation is weird because it's a generic top level for ALL types of inputs so it should allow for all the properties of all inputs
		// instead of spelling out each and every option for all the inputs here, just rest spread them in to this.
		Object.assign(this, rest);

		if (!this.key) {
			console.error('InputInformation requires a key. by default it uses the field name if the key is not specified.', this);
		}
	}
}

// Known input types
InputInformation.COMPONENTS = Components;

// sizes for inputs; relates to css selectors in main.css
InputInformation.SIZE = size;
